module.exports = __webpack_public_path__ + "img/seaPalace-4.9576981e.jpg";